<template>
    <div>
        <div>
            <router-link to="/view-orders" style="font-size:14px;line-height:30px;color:#98c14b;display:flex">
                <p>
                    <a-icon type="double-left" />
                </p>
                <p>Go Back To View Order</p>

            </router-link>

            <h3 style="font-size:28px;line-height:45px">Campaign #{{ displayInvoiceId ? displayInvoiceId : 'N/A' }}</h3>

            <div>
                <div style="background:#fbfbfb;padding: 10px;box-shadow: rgb(136 136 136 / 42%) 0px 2px 8px">
                    <a-row>
                        <a-col style="border-right: dotted;height: 150px;padding: 20px;" :span="9">
                            <a-col>
                                <div style="display:flex;justify-content: center;">
                                    <img class="img_size" src="../../assets/img/inventory_1.png" />
                                </div>
                            </a-col>
                            <a-col style="text-align:center;padding-top:10px">
                                {{ showCampaignDate.startDate }} - {{ showCampaignDate.endDate }} <span
                                    style="color:green">({{ showCampaignDate.numberOfDays }})</span>
                            </a-col>
                            <a-col style="text-align:center;padding-top:10px">
                                StartDate - EndDate
                            </a-col>

                        </a-col>
                        <a-col style="border-right: dotted;height: 150px;padding: 20px;text-align:center" :span="7">

                            <img class="img_size" src="../../assets/img/filledoutline.png" />
                            <div style="padding-top:20px; text-align: -webkit-center;">
                                <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #fff2d6;width: 118px;height: 27px;border-radius: 30px"
                                    v-if="items.statusLabel === 'Pending'">
                                    <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
                                    <p style="font-size:12px;color:#ffb102;"> {{ items.statusLabel }} </p>
                                </div>
                                <div style="display: flex;padding-top: 4px;justify-content: space-around;background: rgb(112 236 110 / 55%);width: 118px;height: 27px;border-radius: 30px"
                                    v-if="items.statusLabel === 'Live'">
                                    <!-- <p style="width: 9px;height: 9px;background: #134e12;margin-top: 5px;border-radius:50%"></p> -->
                                    <p style="font-size:12px;color:rgb(23 140 20);"> {{ items.statusLabel }} </p>
                                </div>
                                <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #d1edfc;width: 118px;height: 27px;border-radius: 30px"
                                    v-if="items.statusLabel === `Completed`">
                                    <!-- <p style="width: 9px;height: 9px;background: #41c4fd;margin-top: 5px;border-radius:50%"></p> -->
                                    <p style="font-size:12px;color:#41c4fd;"> {{ items.statusLabel }} </p>
                                </div>
                            </div>
                        </a-col>
                        <a-col style="height: 100px;padding: 20px;text-align:center" :span="7">
                            <img class="img_size" src="../../assets/img/cowtribe_logo.png" />
                            <a-col style="text-align:center;padding-top:10px;font-size:20px;font-weight:bolder">
                                Ksh 21,000
                            </a-col>
                            <a-col style="text-align:center;padding-top:10px">
                                Total Order Value
                            </a-col>
                        </a-col>
                    </a-row>
                </div>



                <div style="padding-top:30px;padding-bottom:30px">
                    <div style="display:flex;justify-content: space-between;margin-bottom">
                        <!-- <p>Breakdown:</p> -->
                        <div>
                            <p  style="font-size:18px">Aggregate Pre-Orders</p>
                        <div>



                        <div style=" display:flex; justify-content: flex-end;">
                            <a-button @click="showAggregate"
                                style="width:159px; height:33px; border-radius:5px; background: #418a49; color:#fff;">
                                Aggregate Order
                            </a-button>
                        </div>

                    </div>
                    <a-table :columns="columns" :data-source="tableData" :pagination="pagination"
                        :loading="tableLoading" @change="handleTableChange" class="productTable">
                        <span slot="action" slot-scope="">
                            <!-- <router-link style="color:#98c14b;" to="/order-details"><a-icon style="font-size:25px;" type="ellipsis" /> </router-link> -->
                            <!-- <a @click="showMoreDetails(data)" style="color:#98c14b;"><a-icon style="font-size:25px;" type="ellipsis" /> </a> -->
                            <a-dropdown>
                                <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                    <a-icon style="font-size:25px;" type="ellipsis" />
                                </a>
                                <!-- <a-menu slot="overlay">
                                    <a-menu-item>
                                        <a @click="showMoreDetailsModal(data)">Edit Campaign?</a>
                                    </a-menu-item>
                                    <a-menu-item>
                                        <a @click="showMoreDetails(data)">View Order?</a>
                                    </a-menu-item>
                                    <a-menu-item>
                                        <a @click="showPriceModal(data)">Generate PO?</a>
                                    </a-menu-item>
                                    <a-menu-item>
                                        <a @click="showPriceModal(data)">Generate Waybill?</a>
                                    </a-menu-item>
        
                                </a-menu> -->
                            </a-dropdown>
                        </span>
                    </a-table>
                </div>

            </div>
        </div>
        </div>
    </div>
</div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';


const columns = [

    {
        title: 'Date Ordered',
        dataIndex: 'orderedAt',
        key: "orderedAt"
        // width: 200,
    },
    {
        title: 'Product Name',
        dataIndex: 'brandName',
        key: "brandName"
        //  width: 150,
    },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: "quantity"
        // width: 150,
    },
    {
        title: 'Order Value',
        key: 'orderValue',
        dataIndex: 'orderValue',
    },
    {
        title: 'Origination',
        key: 'distributionCenter',
        dataIndex: 'distributionCenter',
    },
    // {
    // 	title: 'Status',
    // 	key: 'status',
    //   dataIndex: 'status',
    //   scopedSlots: { customRender: 'status' }
    // },

    // {
    // 	title: 'Action',
    // 	key: 'action',
    // 	dataIndex: 'action',
    // 	scopedSlots: { customRender: 'action' }
    // },
];



export default {
    name: "ViewAllPreOrder",
    // props: ['items'],
    data() {
        return {
            items: {},
            columns,
            tableData: [],
            params: {
                page: 1,
                perPage: 20,
                searchBy: {},
                sortBy: {}
            },
            tableLoading: false,
            pagination: {
                pageSize: 20
            },
        };
    },
    computed: {
        ...mapGetters(['getOrder']),
        displayInvoiceId() {
            return this.items.id
        },
        showCampaignDate() {
            const today = moment();
            let startDate = moment(this.items.startDate).format("DD-MMM-YYYY")
            let endDate = moment(this.items.endDate).format("DD-MMM-YYYY")
            let numberOfDays = ""

            // console.log(" statusLabel | ", this.items.statusLabel)
            if (this.items.statusLabel === "Pending") {
                numberOfDays = `${moment(this.items.startDate).diff(today.format(), 'days')} days to start campaign`
            }

            if (this.items.statusLabel === "Completed") {
                numberOfDays = `${moment(today.format()).diff(this.items.endDate, 'days')} days after the end of campaign`
            }

            if (this.items.statusLabel === "Live") {
                numberOfDays = `${moment(this.items.endDate).diff(today.format(), 'days')} days at the end of campaign`
            }

            return {
                startDate: startDate,
                endDate: endDate,
                numberOfDays: numberOfDays
            }
        },
        showOrderStatus() {
            return this.items.status == "Pending" ? true : false
        }
    },
    methods: {
        ...mapActions(['getPreOrdersProductsAsync']),
        addPreProduct() {
            this.$router.push('/new-pre-product').catch(() => { });
        },
        showAggregate() {
            this.$router.push('/aggregate-order').catch(() => { });
        },
        handleTableChange(pagination) {
            this.tableLoading = true
            // console.log("pagination in change | ", pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.params.page = pagination.current;
            this.params.perPage = pagination.pageSize;
            this.params.searchBy = {
                preorderCampaignId: this.items.id
            }

            this.getPreOrdersProducts(this.params);
        },
        getPreOrdersProducts(request_data) {
            this.tableLoading = true;
            this.getPreOrdersProductsAsync(request_data).then(response => {
                this.tableLoading = false;
                // console.log('response in sales | ', response)
                if (response.status === 200) {
                    const pagination = { ...this.pagination };
                    pagination.total = response.data.totalRecords;
                    let results = response.data.data;

                    this.tableData = results.map(product => ({
                        key: product.id,
                        brandName: product.brandName,
                        quantity: product.quantity,
                        orderValue: product.orderValue ? product.orderValue : "N/A",
                        distributionCenter: product.distributionCentreName,
                        status: product.status,
                        orderedAt: moment(product.orderedAt).format("DD-MMM-YYYY"),
                        action: product
                    }))
                    this.pagination = pagination;
                } else {
                    this.tableLoading = false;
                    console.log('Error | ', response)
                }
            },
                error => {
                    this.tableLoading = false;
                    console.log('Error | ', error)
                })
        },
        loadPreOrdersProducts() {
            this.params.searchBy = {
                preorderCampaignId: this.items.id
            }
            this.getPreOrdersProducts(this.params)
        }
    },
    created() {
        // console.log(" getOrder in created | ", this.getOrder);
        if (this.getOrder) {
            this.items = this.getOrder
        }
        if (this.loadPreOrdersProducts) {
            this.loadPreOrdersProducts();
        }
    }
}
</script>

<style scoped>
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

.img_size {
    max-width: 40px;
    max-height: 40px;
}

.productTable>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.productTable>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.productTable>>>.ant-pagination-item-active a {
    color: #fff;
}

.productTable>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.fulfillmentTable>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.fulfillmentTable>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.fulfillmentTable>>>.ant-pagination-item-active a {
    color: #fff;
}

.fulfillmentTable>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
</style>